<!--
作者：Loong
时间：2020/07/17
-->
<!-- propertyInfoChange [ 业主信息修改 ] -->
<template>

    <div id='propertyInfoChange'>
        <div class="userSet_search" style="margin-top: 20px ;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="getData">

				<el-form-item label="户号">
					<el-input v-model="select.account" placeholder="户号" style="width:170px;" :maxlength="12"></el-input>
				</el-form-item>

                <el-form-item label="业主名称">
					<el-input v-model="select.name" placeholder="业主名称" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="业主手机号">
					<el-input v-model="select.phone" placeholder="业主手机号" style="width:170px;"></el-input>
				</el-form-item>

                <!-- <el-form-item label="缴费金额(元)">
					<el-input v-model="select.money" placeholder="缴费金额(元)" style="width:170px;"></el-input>
				</el-form-item> -->

                <el-form-item label="地址">
					<el-input v-model="select.address" placeholder="地址" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="状态">
					<el-select v-model="select.status" placeholder="请选择" style="width: 140px;">
						<el-option :label="'已缴费'" :value="1"></el-option>
						<el-option :label="'未缴费'" :value="0"></el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="费用周期">
                    <el-date-picker v-model="select.begin_date" type="date" placeholder="开始时间" style="width:170px;"> </el-date-picker>
                    <el-date-picker v-model="select.end_date" type="date" placeholder="结束时间" style="width:170px;"> </el-date-picker>
				</el-form-item>

                <el-form-item label="缴费时间">
                    <el-date-picker v-model="select.start_time" type="date" placeholder="开始时间" style="width:170px;"> </el-date-picker>
                    <el-date-picker v-model="select.end_time" type="date" placeholder="结束时间" style="width:170px;"> </el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="onAdd">添加</el-button>
					<el-button type="primary" @click="getData">查询</el-button>
					<el-button type="primary" @click="resetting">重置</el-button>
					<el-button type="primary" @click="downCode()">导出</el-button>
				</el-form-item>

			</el-form>
		</div>

        <el-table :data="dataset" border style="width:1675px;text-align:center;margin-bottom: 10px;font-size:12px; " v-on:sort-change="getData">

			<el-table-column prop="account" label="户号" width="123" align="center"></el-table-column>

			<el-table-column prop="name" label="业主名称" width="" align="center"></el-table-column>

			<el-table-column prop="phone" label="业主手机" width="" align="center"></el-table-column>

			<el-table-column prop="money" label="缴费金额" width="" align="center"></el-table-column>

			<el-table-column prop="address" label="地址" width="" align="center"></el-table-column>

			<el-table-column prop="begin-end" label="费用周期" width="190" align="center"></el-table-column>

			<el-table-column prop="pay_time" label="缴费时间" width="190" align="center"></el-table-column>

			<el-table-column prop="status" label="状态" width="" align="center">
                <template scope="scope">
					{{scope.row.status == '1' ? '已缴费' : '未缴费'}}
				</template>
            </el-table-column>

			<el-table-column prop="payment_detail" label="缴费明细" width="" align="center"></el-table-column>

			<el-table-column prop="remark" label="备注" width="" align="center"></el-table-column>

			<el-table-column prop="" label="操作" width="260" align="center">
				<template scope="scope">
					<el-button type="primary" size="mini" @click="editInfo(scope.$index,scope.row)">修改</el-button>
					<el-button type="primary" size="mini" @click="onDel(scope.$index,scope.row)">删除</el-button>
					<el-button type="primary" size="mini" @click="onXQ(scope.$index,scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="page=$event; getData()" :page-size="pageSize" layout="total,prev, pager, next" :total="total"></el-pagination>

        <PropertyInfoChangeEdit :type="PICType" :loadData="rowData" v-if="PICChangeShow" @onClose="onCloseInfo" />

    </div>

</template>

<script>
import PropertyInfoChangeEdit from '@/components/PropertyInfoChangeEdit';
export default {
    components: { PropertyInfoChangeEdit },

    props: [],

    data() {
        return{
            natures: [],

            select: {
                account: '',
                name: '',
                phone: '',
                // money: '',
                address: '',
                begin_date: '',
                end_date: '',
                start_time: '',
                end_time: '',
                status: '',
            },

            dataset: [],
            page: 1,
            total: 0,
            pageSize: 15,
            prop: '',
            order: '',

            // 修改信息
            rowData: {},
            PICChangeShow: false,
            PICType: 0,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },
        getData(item){
            this.$jssdk.property.get_info({
                id: this.$route.query.id,
                page: this.page,
                account: this.select.account,
                name: this.select.name,
                phone: this.select.phone,
                // money: this.select.money,
                address: this.select.address,
                begin_date: this.formatDateTime(this.select.begin_date),
                end_date: this.formatDateTime(this.select.end_date),
                start_time: this.formatDateTime(this.select.start_time),
                end_time: this.formatDateTime(this.select.end_time),
                status: this.select.status,
            }, (r) =>{
                this.dataset = r.data;
                this.total = r.total;
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 添加
        onAdd(){
            this.PICType = 1;
            this.PICChangeShow = true;
        },

        // 重置
        resetting() {
            this.select.account = '';
            this.select.name = '';
            this.select.phone = '';
            // this.select.money = '';
            this.select.address = '';
            this.select.begin_date = '';
            this.select.end_date = '';
            this.select.start_time = '';
            this.select.end_time = '';
            this.select.status = '';
        },

        // 导出
        downCode() {
            this.$jssdk.property.get_info({
                id: this.$route.query.id,
                page: this.page,
                account: this.select.account,
                name: this.select.name,
                phone: this.select.phone,
                // money: this.select.money,
                address: this.select.address,
                begin_date: this.formatDateTime(this.select.begin_date),
                end_date: this.formatDateTime(this.select.end_date),
                start_time: this.formatDateTime(this.select.start_time),
                end_time: this.formatDateTime(this.select.end_time),
                status: this.select.status,
                is_export: '1',
            },(r) =>{
                window.location.href = r.url
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 修改业主信息
        editInfo(index, row){
            this.PICType = 2;
            this.rowData = row;
            this.PICChangeShow = true;
        },
        // 关闭信息
        onCloseInfo(){
            this.PICChangeShow = false;
            this.getData();
        },

        // 重置密码相关
        onXQ(index, row) {
            this.PICType = 3;
            this.rowData = row;
            this.PICChangeShow = true;
        },

        // 删除
        onDel(index, row){
            this.$confirm('确定删除此项？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$jssdk.property.delInfo({
                    id: row.id
                }, r => {
                    this.$message({
                        type:'success',
                        message: '已删除',
                        duration:2000
                    })
                    this.getData();
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.data,
                        duration:2000
                    })
                })
            });
        },

        // 获取日期时间字符串
        formatDateTime(dates){
            if(dates == '') return '';
            let y = dates.getFullYear() >= 10 ? dates.getFullYear() : ('0' + dates.getFullYear());
            let m = (dates.getMonth() + 1) >= 10 ? (dates.getMonth() + 1) : '0' + (dates.getMonth() + 1);
            let d = dates.getDate() >= 10 ? dates.getDate() : '0' + dates.getDate();
            let hh = dates.getHours() >= 10 ? dates.getHours() : '0' + dates.getHours();
            let mm = dates.getMinutes() >= 10 ? dates.getMinutes() : '0' + dates.getMinutes();
            let ss = dates.getSeconds() >= 10 ? dates.getSeconds() : '0' + dates.getSeconds();
            return (y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss);
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>


// WEBPACK FOOTER //
// PropertyInfoChange.vue?64042347